import React from 'react';
import 'antd/dist/antd.css';
import './lana.scss';
import './App.scss';
import { BrowserRouter } from 'react-router-dom';
import Router from './components/router';

function App() {
  return (
    <BrowserRouter>
      <Router />
    </BrowserRouter>
  );
}

export default App;
